import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { BaseDialogActionData, ButtonColor, CommonActionKey } from '../../../../../../ui/dialog/base-dialog/base-dialog.model';
import { CreateBrokerApiKeySuccessData } from '../../../../broker-api-key.model';

@Component({
    selector: 'ifc-broker-api-key-details-dialog',
    templateUrl: './broker-api-key-details-dialog.component.html',
    styleUrls: ['./broker-api-key-details-dialog.component.scss'],
    standalone: false
})
export class BrokerApiKeyDetailsDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary },
  ];
  
  constructor(
    public dialogRef: MatDialogRef<BrokerApiKeyDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    copy(text: string): void {
      navigator.clipboard.writeText(text);
    }

    static show(dialog: MatDialog, apiKey: CreateBrokerApiKeySuccessData): Observable<any> {
      return dialog.open(BrokerApiKeyDetailsDialogComponent, {
        width: '510px',
        data: {
          apiKey: apiKey
        },
        closeOnNavigation: true,
      }).afterClosed();
    }

    onActionClicked(actionData: BaseDialogActionData): void {
      if (actionData.actionKey === CommonActionKey.Ok) {
        this.dialogRef.close(true);
        return;
      }
  
      this.dialogRef.close();
    }
}
